import React, { useState } from 'react';
import ResidentialCalculatorSellersNet from './residential/ResidentialCalculatorSellersNet';
import { initalDate } from '../../../lib/helpers';

const CalculatorSellersNet = ({ calculatorType, calculatorConstants }) => {
  // the variable contants that are used for the calculations functions
  const calculatorVariableConstants = {
    home_equity_percentage: 0.1,
    home_equity_supplemental_percentage: 0.15,
    res_survey_deletion_shared_percentage: 0.05,
    res_survey_deletion_only_percentage: 0.05,
    res_t_19_1_shared_percentage: 0.05,
    res_t_19_1_only_percentage: 0.1,
    com_survey_deletion_shared_percentage: 0.15,
    com_survey_deletion_only_percentage: 0.15,
    com_t_19_1_shared_percentage: 0.1,
    com_t_19_1_only_percentage: 0.15
  };

  return (
    <ResidentialCalculatorSellersNet
      calculatorVariableConstants={calculatorVariableConstants}
      calculatorConstants={calculatorConstants}
      date={initalDate()}
    />
  );
};

export default CalculatorSellersNet;
